<template>
  <section class="count-section">
    <div class="count-section__container">
      <h2 class="count-section__title">Количество учреждений</h2>
      <ul class="count-section__row">
        <li class="count-section__column" title="23 школы" v-for="(count, index) in $store.state.homeStatistics" :key="index">
          <h3 class="count-section__count">{{ count.count }}</h3>
          <span class="count-section__count-subtitle">{{ count.title }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CountSection'
}
</script>
